import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { Link } from 'react-router-dom';
import { fetchGalleries } from '../../services/api';

function GalleryInner() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [galleries, setGalleries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadGalleries();
    }, []);

    const loadGalleries = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await fetchGalleries(1);
            setGalleries(response.galleries);
        } catch (err) {
            setError(err.message || 'Failed to load galleries. Please try again later.');
            console.error('Error loading galleries:', err);
        } finally {
            setLoading(false);
        }
    };

    // Function to open the modal with the selected image
    const openModal = (imageSrc, event) => {
        event.preventDefault(); // Prevent default link behavior
        setModalImage(imageSrc);
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="overflow-hidden space" id="gallery-sec">
            <div className="container-fuild">
                <div className="title-area mb-30 text-center">
                    <span className="sub-title">Explore Us</span>
                    <h2 className="sec-title">Our Gallery</h2>
                </div>
                
                {loading && (
                    <div className="text-center py-5">
                        <p>Loading galleries...</p>
                    </div>
                )}
                
                {error && (
                    <div className="alert alert-danger" role="alert">
                        <strong>Error:</strong> {error}
                    </div>
                )}
                
                {!loading && !error && galleries.length === 0 && (
                    <div className="text-center py-5">
                        <p>No galleries found.</p>
                    </div>
                )}
                
                {!loading && !error && galleries.length > 0 && (
                    <div className="row gy-4 gallery-row4">
                        {galleries.map((gallery) => (
                            <div key={gallery.id} className="col-auto">
                                <div className="gallery-box style5">
                                    <div className="gallery-img global-img">
                                        <img 
                                            src={gallery.image} 
                                            alt={gallery.title || 'gallery'} 
                                        />
                                        {gallery.title && (
                                            <div 
                                                className="gallery-title-overlay"
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    background: 'rgba(0, 0, 0, 0.4)',
                                                    padding: '12px 10px 10px',
                                                    color: '#fff',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    textAlign: 'center',
                                                    pointerEvents: 'none',
                                                    backdropFilter: 'blur(2px)'
                                                }}
                                            >
                                                <span>{gallery.title}</span>
                                            </div>
                                        )}
                                        <Link
                                            to={gallery.image}
                                            className="icon-btn popup-image"
                                            onClick={(e) => openModal(gallery.image, e)}
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
        </div>
    )
}

export default GalleryInner
